import { getErrors } from 'core/helpers'
import { Dispatch } from 'react'
import { UnknownAction } from 'redux'

const errorsAction =
    (e: unknown, actionType: string) => (dispatch: Dispatch<UnknownAction>) => {
        return dispatch({
            type: actionType,
            payload: { errors: getErrors(e) }
        })
    }

export default errorsAction